import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "TurnOffFocusedOther" */ './lazyIndex');
});
export var TurnOffFocusedOtherItem = createLazyComponent(lazyModule, function (m) { return m.TurnOffFocusedOtherItem; });
//# sourceMappingURL=index.js.map